import service from './service';
import { UrlBuilder } from './url-builder';

const getAddressBooks = async (payload) => {
  const response = await service.get('/users/address-book');

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

const uploadCsvToBackend = async (payload) => {
  const builder = new UrlBuilder(`/users/address-book`);
  try {
    const response = await service.uploadFile(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export { getAddressBooks, uploadCsvToBackend };
